module.exports = __webpack_public_path__ + "RMR ACH Authorization Form.pdf";